/**
 * @fileoverview useMarketingLoginAuth — patrol-web's cross-domain marketing-login
 * auth hook. MKT-LOGIN-XDOMAIN-001 (2026-06-29): the reducer + login/MFA
 * orchestration live in the shared `@puffin-core/login-shell`
 * `createMarketingLoginAuth` factory; this module supplies patrol-web's
 * dependency injection only.
 *
 * patrol-web injects the RAW tenant auth legs (`marketingLoginAuthService`). No
 * passkey here: a passkey is bound to the tenant origin's rpId and the marketing
 * apex holds none, so passkey sign-in lives on the tenant login page (login-shell
 * `usePasskeyLogin`); the factory has no passkey option since USER-FACING-GEMS L1b.
 *
 * @module portals/marketing-website/hooks/useMarketingLoginAuth
 */

import { createMarketingLoginAuth } from '@puffin-core/login-shell';
import { marketingLoginAuthService } from '../../../features/auth/services/authService';

// MKT-LOGIN-XDOMAIN-001/HANDOFF: no `storeAuthData` — the cross-domain login does
// NOT persist tokens on the marketing origin (they can't cross to the tenant
// origin). The login/verify result is handed to the `/v1/auth/cross-app/handoff`
// mint; the tenant origin exchanges the `?cat=` token into its own session.
export const useMarketingLoginAuth = createMarketingLoginAuth({
  authService: marketingLoginAuthService,
});

export default useMarketingLoginAuth;
